var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-body', {
    staticClass: "p-6"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('div', {
    staticClass: "badge badge-pill badge-gold mr-4"
  }, [_c('i', {
    staticClass: "fas fa-birthday-cake",
    staticStyle: {
      "font-size": "1.5rem"
    }
  })]), _c('div', [_c('b-card-title', {
    staticClass: "mb-0"
  }, [_vm._v("Aniversariantes")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formattedToday))])], 1)]), _vm.loading ? [_c('ul', {
    staticClass: "list-unstyled m-0 p-0 mt-4"
  }, _vm._l(5, function (i) {
    return _c('li', {
      key: i,
      staticClass: "d-flex align-items-center mb-4"
    }, [_c('div', {
      staticClass: "flex-grow-1"
    }, [_c('b-skeleton', {
      attrs: {
        "width": "40%",
        "height": "16px"
      }
    }), _c('b-skeleton', {
      staticClass: "mt-2",
      attrs: {
        "width": "25%",
        "height": "12px"
      }
    })], 1), _c('div', {
      staticClass: "ml-3",
      staticStyle: {
        "width": "120px",
        "text-align": "right"
      }
    }, [_c('b-skeleton', {
      attrs: {
        "width": "60px",
        "height": "24px"
      }
    })], 1)]);
  }), 0)] : [_c('b-table', {
    staticClass: "tabela-aniversariantes mt-4",
    attrs: {
      "items": _vm.items,
      "fields": _vm.camposTabela,
      "responsive": "sm",
      "small": "",
      "show-empty": "",
      "empty-text": 'Nenhum aniversariante hoje'
    },
    scopedSlots: _vm._u([{
      key: "cell(nome_e_idade)",
      fn: function fn(row) {
        return [_c('div', [_vm._v(_vm._s(row.item.nome))]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(row.item.data_nascimento)) + " ")])];
      }
    }, {
      key: "cell(idade)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "align-middle"
        }, [_vm._v(_vm._s(row.item.idade))])];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(row) {
        return [row.item.telefone ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              _vm.openWhats(row.item.telefone, _vm.getBirthdayMessage(row.item));
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-1",
          attrs: {
            "icon": "whatsapp",
            "variant": "primary"
          }
        }), _vm._v(" Parabenizar ")], 1) : _c('div', {
          staticClass: "text-muted mr-3",
          staticStyle: {
            "font-size": "0.9rem"
          }
        }, [_vm._v(" Sem WhatsApp ")])];
      }
    }])
  })]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };